import { styled } from '@mui/system';
import { ListItemIcon } from '@mui/material';
import themeCreator from "@Themes/themeCreator";

const theme = themeCreator()

const StyledListItemIcon = styled(ListItemIcon)(({ selectedIndex, index }) => ({
  color: selectedIndex === index ? theme.palette.primary.main : theme.palette.primary.light,
}));

export default StyledListItemIcon;
